import React from 'react';
import PropTypes from 'prop-types';
import { StyledCard, CardHeader, StyledImgContainer, StyledTitle, StyledContentContainer } from './Card.styles';

const Card = ({ title, image, children }) => (
  <StyledCard>
    <CardHeader>
      <StyledImgContainer>
        <img src={image} alt="card-logo" />
      </StyledImgContainer>
      <StyledTitle>{title}</StyledTitle>
    </CardHeader>

    <StyledContentContainer>{children}</StyledContentContainer>
  </StyledCard>
);

Card.propTypes = {
  title: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]).isRequired,
  image: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export default Card;
